import React from 'react';
import { Check, Users } from 'lucide-react';
import { User } from '../../types';

interface ParticipantSelectorProps {
  members: User[];
  selectedIds: string[];
  assigneeId?: string;
  onChange: (participantIds: string[]) => void;
}

export function ParticipantSelector({ members, selectedIds, assigneeId, onChange }: ParticipantSelectorProps) {
  const availableMembers = members.filter(member => member.id !== assigneeId);

  const toggleParticipant = (memberId: string) => {
    onChange(
      selectedIds.includes(memberId)
        ? selectedIds.filter(id => id !== memberId)
        : [...selectedIds, memberId]
    );
  };

  if (availableMembers.length === 0) {
    return <p className="text-sm text-gray-400">Nenhum participante disponível</p>;
  }

  return (
    <div className="max-h-32 space-y-1 overflow-y-auto rounded border border-gray-200 bg-gray-50 p-2">
      {availableMembers.map(member => {
        const isSelected = selectedIds.includes(member.id);

        return (
          <button
            key={member.id}
            type="button"
            onClick={() => toggleParticipant(member.id)}
            className={`flex w-full items-center gap-2 rounded px-2 py-1.5 text-left text-sm transition-colors ${
              isSelected ? 'bg-primary-50 text-primary-700' : 'text-gray-600 hover:bg-white'
            }`}
            aria-pressed={isSelected}
          >
            <span className={`flex h-5 w-5 items-center justify-center rounded-full ${isSelected ? 'bg-primary-600 text-white' : 'bg-gray-200 text-gray-500'}`}>
              {isSelected ? <Check size={12} strokeWidth={3} /> : <Users size={11} />}
            </span>
            <span className="truncate">{member.name}</span>
          </button>
        );
      })}
    </div>
  );
}
